import { render, staticRenderFns } from "./MaterialParameter.vue?vue&type=template&id=c18784da&scoped=true&"
import script from "./MaterialParameter.vue?vue&type=script&lang=ts&"
export * from "./MaterialParameter.vue?vue&type=script&lang=ts&"
import style0 from "./MaterialParameter.vue?vue&type=style&index=0&id=c18784da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18784da",
  null
  
)

export default component.exports